class CustomWishlist extends HTMLElement {
    
    customerId      = this.getAttribute("customer-id");
    rcIdentifierKey = "random-customer-identifier";
    rcIdentifier    = window.localStorage.getItem(this.rcIdentifierKey);

    constructor() {
        super();
        this.setupEventListeners();
        this.initWishlist();
    }

    setupEventListeners() {
        window.addEventListener(`product-added-to-wishlist`, (event) => {
            const { productId, productUrl } = event.detail; // Captura data-url
            if (!productId) {
                return console.error("Invalid event");
            }
            this.addProductToWishlist(productId, productUrl);
        });
    }

    async addProductToWishlist(productId, productUrl) {
        console.log("This is the customerID add ", this.customerId);
        console.log("This is the rcIdentifier add ", this.rcIdentifier);
        console.log("This is the prodcutID add ", productId);
        console.log("This is the productUrl add ", productUrl); 

        let data = new FormData();
            data.set("customerId",      this.customerId   ?? "");
            data.set("rcIdentifier",    this.rcIdentifier ?? "");
            data.set("productId",       productId);
            data.set("productUrl",      productUrl);
            
        let response = await fetch(`https://tamatoby.tible.tech/wishlist-add.json`, {
            method: "POST",
            body: data,
        });

        if (response.status !== 200) {
            return console.error("Invalid response status", response.status, response);
        } 

        let wishlistResponse = await response.json();

        console.log("Wishlist Response:", wishlistResponse);

        if (!wishlistResponse.ok) {
            return console.error("Invalid response", wishlistResponse);
        }

        window.dispatchEvent(new CustomEvent("added-to-wishlist", {detail: {productId: this.productId, productUrl: this.productUrl}}));
        
        this.initWishlist();
    }

    async initWishlist() {
        let shouldCenter = this.getAttribute("data-center-loading") === "true";
        let isMobile = window.innerWidth <= 768;

        if(shouldCenter) {
            this.innerHTML = `LOADING WISHLIST...`;
            // En mobile no centrar con flex, dejar que el CSS del padre lo maneje
            if (!isMobile) {
                this.style.display = "flex";
                this.style.justifyContent = "center";
                this.style.alignItems = "center";
            } else {
                this.style.display = "block";
            }
            this.style.height = isMobile ? "auto" : "100%";
            this.style.width = "100%";
            this.style.fontSize = "14px";
        } else {
            this.innerHTML = `LOADING WISHLIST...`;
        }

        if (!this.customerId) {
            if (!this.rcIdentifier) {
                this.rcIdentifier = `rc_${Date.now()}${parseInt(Math.random()*Math.pow(10, 5))}`;
                window.localStorage.setItem(this.rcIdentifierKey, this.rcIdentifier);
            }
        } else {
            if (this.rcIdentifier) {
                let data = new FormData();
                    data.set("customerId",   this.customerId   ?? "");
                    data.set("rcIdentifier", this.rcIdentifier ?? "");
                    
                let response = await fetch(`https://tamatoby.tible.tech/link-wishlist.json`, {
                    method: "POST",
                    body: data,
                });

                if (response.status === 200) {
                    let wishlistResponse = await response.json();
                    if (wishlistResponse.ok) {
                        window.localStorage.removeItem(this.rcIdentifierKey);
                    }
                } 
            }
        }

        let wishlist = await this.getWishlist();
        if (!wishlist || !wishlist.length) {
            this.innerHTML = `YOUR WISHLIST IS EMPTY`;
            this.style.fontSize = "14px";
            return;
        }

        this.innerHTML = ``;

        // Crea el contenedor con la clase "wishlist-grid" para la vista de página completa
        let gridContainer = document.createElement("div");
        const layout = this.getAttribute("data-layout");

        if (layout === "grid") {
            gridContainer.classList.add("wishlist-grid");
        } else {
            gridContainer.classList.add("wishlist-list"); // Clase para diseño de columna
        }

        // Agrega cada producto al contenedor
        wishlist.forEach(item => {
            let productNode = this.getWishlistItemNode(item);
            gridContainer.appendChild(productNode);
        });

        // Añade el contenedor a la página
        this.appendChild(gridContainer);
    }

    async getWishlist() {
        
        let data = new FormData();
            data.set("customerId",   this.customerId   ?? "");
            data.set("rcIdentifier", this.rcIdentifier ?? "");
            
        let response = await fetch(`https://tamatoby.tible.tech/wishlist.json`, {
            method: "POST",
            body: data,
        });

        if (response.status !== 200) {
            return;
        } 

        let wishlistResponse = await response.json();

        if (!wishlistResponse.ok) {
            return;
        }

        console.log("Wishlist items:", wishlistResponse.items);

        return wishlistResponse.items;        
    }
    
    async removeFromWishlist(productId) {
        
        let data = new FormData();
            data.set("customerId",   this.customerId   ?? "");
            data.set("rcIdentifier", this.rcIdentifier ?? "");
            data.set("productId",    productId);
            
        let response = await fetch(`https://tamatoby.tible.tech/wishlist-remove.json`, {
            method: "POST",
            body: data,
        });

        if (response.status !== 200) {
            return console.error("Invalid response status", response.status, response);
        } 

        let wishlistResponse = await response.json();

        if (!wishlistResponse.ok) {
            return console.error("Invalid response", wishlistResponse);
        }

        window.dispatchEvent(new CustomEvent("removed-from-wishlist", {detail: {productId: this.productId}}));
        
        this.initWishlist();       
    }
    
    async getAvailability(productId) {
        
        console.log("this is the productID getAvailability", productId);


        let data = new FormData();
            data.set("customerId",   this.customerId   ?? "");
            data.set("rcIdentifier", this.rcIdentifier ?? "");
            data.set("productId",    productId);
            
        let response = await fetch(`https://tamatoby.tible.tech/get-availability.json`, {
            method: "POST",
            body: data,
        });

        if (response.status !== 200) {
            return console.error("Invalid response status", response.status, response);
        } 

        let wishlistResponse = await response.json();

        if (!wishlistResponse.ok) {
            return console.error("Invalid response", wishlistResponse);
        }

        return wishlistResponse.variants;
    }

    async addVariantToCartAndRemoveFromWishlist(variantId, productId) {
        const formData = {
            'items': [{
                'id': variantId,
                'quantity': 1
            }]
        };
        
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            
            if (response.ok) {
                await this.removeFromWishlist(productId);
                
                if (typeof window.updateMinicart === 'function') {
                    window.updateMinicart();
                }
            } else {
                console.error('Error adding product to cart:', await response.json());
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred. Please try again.');
        }
    }
    
    showVariantSelector(variants, productId, basePrice) {
        const price = basePrice || 0;

        const styleSheet = document.createElement('style');
        styleSheet.textContent = `
            #variant-selector,
            #variant-selector option {
                font-size: 14px !important;
            }
        `;
        document.head.appendChild(styleSheet);
        
        const variantOptions = variants.map(v => 
            `<option value="${v.id}">${v.title}</option>`
        ).join('');
        
        const overlay = document.createElement('div');
        overlay.id = "variant-selector-overlay";
        overlay.style.cssText = "position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);z-index:1000;display:flex;justify-content:center;align-items:center;";
        
        overlay.innerHTML = `
            <div style="
                background: white;
                padding: 20px;
                width: 100%;
                max-width: 400px;
                font-family: 'Neue Haas Display', sans-serif !important;
                position: relative;
                margin: 20px;
            ">
                <button id="cancel-variant" style="
                    position: absolute;
                    right: 20px;
                    top: 15px;
                    background: none;
                    border: none;
                    font-size: 20px;
                    cursor: pointer;
                    padding: 5px;
                ">×</button>
                
                <h3 style="
                    margin: 0 0 15px 0;
                    font-size: 14px;
                    font-family: 'Neue Haas Display', sans-serif !important;
                    text-transform: uppercase;
                    letter-spacing: 1px;
                    font-weight: 500;
                ">SELECT SIZE</h3>
                
                <select id="variant-selector" style="
                    width: 100%;
                    padding: 15px;
                    margin: 10px 0 25px;
                    border: 1px solid #e0e0e0;
                    background: white;
                    apparence: none;
                    font-size: 14px;
                    font-family: 'Neue Haas Display', sans-serif !important;
                    appearance: none;
                    background-image: url('data:image/svg+xml;charset=US-ASCII,<svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L7 7L13 1" stroke="black" stroke-width="1.5"/></svg>');
                    background-repeat: no-repeat;
                    background-position: right 15px center;
                    cursor: pointer;
                ">
                    <option value="" disabled selected>CHOSE YOUR SIZE</option>
                    ${variantOptions}
                </select>
                
                <button id="confirm-variant" style="
                    width: 100%;
                    padding: 16px;
                    background: #111111;
                    color: white;
                    border: none;
                    cursor: pointer;
                    text-transform: uppercase;
                    font-size: 14px;
                    font-family: 'Neue Haas Display', sans-serif !important;
                    letter-spacing: 1px;
                    transition: background-color 0.3s;
                ">Add to Bag</button>
            </div>
        `;
    
        document.body.appendChild(overlay);
        
        const cancelButton = document.getElementById('cancel-variant');
        const confirmButton = document.getElementById('confirm-variant');
        const variantSelector = document.getElementById('variant-selector');
        
        // Add hover effect for confirm button
        confirmButton.addEventListener('mouseover', () => {
            confirmButton.style.backgroundColor = '#404040';
        });
        
        confirmButton.addEventListener('mouseout', () => {
            confirmButton.style.backgroundColor = '#1F1F1F';
        });
        
        if (cancelButton) {
            cancelButton.addEventListener('click', () => {
                overlay.remove();
            });
        } else {
            console.error('Cancel button not found');
        }
        
        if (confirmButton && variantSelector) {
            confirmButton.addEventListener('click', () => {
                const selectedVariantId = variantSelector.value;
                if (selectedVariantId) {
                    overlay.remove();
                    this.addVariantToCartAndRemoveFromWishlist(selectedVariantId, productId);
                }
            });
        } else {
            console.error('Confirm button or variant selector not found');
        }
    }

    getWishlistItemNode(item, currency = "EUR") {
        console.log("Esto es el item y lo que contiene - ", item);
        let itemNode = document.createElement("div");
        itemNode.classList.add("cart-item-wrapper");
    
        // Imagen del producto
        let imageNode = document.createElement("div");
        const layout = this.getAttribute("data-layout"); // Verificar el layout
        if (layout === "grid") {
            imageNode.classList.add("wishlist-item-image"); // Clase específica para grid
        } else {
            imageNode.classList.add("cart-item-image-element"); // Clase para diseño original
        }
        imageNode.style.backgroundImage = `URL(${item.product_data?.image?.src ?? ""})`;
        itemNode.appendChild(imageNode);
    
        // Contenedor para texto
        let textNode = document.createElement("div");
        if (layout === "grid") {
            textNode.classList.add("wishlist-item-text"); // Clase específica para grid
        } else {
            textNode.classList.add("cart-item-text-element"); // Clase para diseño original
        }
    
        // Encabezado: título y precio
        let headerWrapper = document.createElement("div");
        if (layout === "grid") {
            headerWrapper.classList.add("wishlist-item-text-wrapper"); // Clase para grid
        } else {
            headerWrapper.classList.add("cart-item-text-element-wrapper"); // Clase para diseño original
        }
    
        // Título del producto
        let titleDiv = document.createElement("div");
        // enlace con el link al pulsar en el titulo
        let link = document.createElement("a");
        link.style.textDecoration = "none";

        if (layout === "grid") {
            titleDiv.classList.add("wishlist-item-title"); // Clase para grid
            link.href = `/products/${item.product_data.handle}`; // Usa el data-url capturado
            link.innerText = `${item.product_data.title}`;
            link.target = "_blank"; 
            titleDiv.appendChild(link);
        } else {
            titleDiv.classList.add("cart-item-title"); // Clase para diseño original
            titleDiv.innerHTML = `${item.product_data.title}`;
        }

        headerWrapper.appendChild(titleDiv);
    
        // Precio del producto
        let priceDiv = document.createElement("div");
        if (layout === "grid") {
            priceDiv.classList.add("wishlist-item-price"); // Clase para grid
        } else {
            priceDiv.classList.add("cart-item-price"); // Clase para diseño original
        }
        priceDiv.innerHTML = `${Math.floor(item.product_data?.variants[0]?.price)} ${currency}`;
        headerWrapper.appendChild(priceDiv);
    
        textNode.appendChild(headerWrapper);
    
        // Agregar botones solo si el diseño no es "grid"
        if (layout !== "grid") {
            let buttonAndVariantSelectorWrapper = document.createElement("div");
            let buttonWrapper = document.createElement("div");
            buttonWrapper.classList.add("cart-item-button");
    
            // Botón "Remove"
            let removeButton = document.createElement("div");
            removeButton.classList.add("cart-item-remove");
            removeButton.innerHTML = `REMOVE`;

            // Evento hover para cambiar el color
            removeButton.addEventListener("mouseover", function () {
                removeButton.style.color = "#c3000d";
            });
            removeButton.addEventListener("mouseout", function () {
                removeButton.style.color = ""; // Restablecer al color original
            });
            removeButton.onclick = async () => {
                await this.removeFromWishlist(item.productId);
            };
            buttonWrapper.appendChild(removeButton);
    
            // Botón "Add to Bag"
            let addToCartButton = document.createElement("div");
            addToCartButton.classList.add("cart-item-remove");
            addToCartButton.innerHTML = `ADD TO BAG`;
            addToCartButton.onclick = async () => {
                try {
                    let variantsAvailability = await this.getAvailability(item.productId);
                    
                    // Filtrar solo las variantes disponibles
                    const availableVariants = variantsAvailability.filter(variant => variant.availableForSale);

                    if (availableVariants.length === 0) {
                        alert('Sorry, this product is currently not available.');
                        return;
                    }
                    
                    if (availableVariants.length === 1) {
                        // Si solo hay una variante disponible, añadirla directamente
                        await this.addVariantToCartAndRemoveFromWishlist(availableVariants[0].id, item.productId);
                    } else {
                        // Mostrar selector de variantes
                        this.showVariantSelector(availableVariants, item.productId, item.product_data?.variants[0]?.price);
                    }
                } catch (error) {
                    console.error('Error:', error);
                    alert('An error occurred. Please try again.');
                }
            };
            buttonWrapper.appendChild(addToCartButton);
    
            buttonAndVariantSelectorWrapper.appendChild(buttonWrapper);
            textNode.appendChild(buttonAndVariantSelectorWrapper);
        }
    
        itemNode.appendChild(textNode);
        return itemNode;
    }    

  
}

customElements.define('custom-wishlist', CustomWishlist);
  